import styled from "styled-components"

export const BaseLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-text-400);

  margin-bottom: var(--size-2);
`

export const BaseHint = styled.span`
  color: var(--color-text-200);
`
